document.addEventListener('DOMContentLoaded', () => {
  const faqItems = document.querySelectorAll('.ninja-faq-item');

  function openItem(item) {
    const answer = item.querySelector('.ninja-faq-answer');
    item.classList.add('active');
    answer.style.maxHeight = answer.scrollHeight + 'px';
  }

  function closeItem(item) {
    const answer = item.querySelector('.ninja-faq-answer');
    item.classList.remove('active');
    answer.style.maxHeight = null;
  }

  // First item open by default
  if (faqItems.length > 0) {
    openItem(faqItems[0]);
  }

  faqItems.forEach((item) => {
    const button = item.querySelector('.ninja-faq-question');
    const answer = item.querySelector('.ninja-faq-answer');

    button.addEventListener('click', () => {
      const isActive = item.classList.contains('active');

      // Close all
      faqItems.forEach(closeItem);

      // Toggle clicked
      if (!isActive) {
        openItem(item);
      }
    });
  });
});